import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-column-toggle',
  templateUrl: './column-toggle.component.html',
  styleUrls: ['./column-toggle.component.css']
})
export class ColumnToggleComponent {

  @Input() currentToggle: boolean;

  @Output() toggleColumn = new EventEmitter<boolean>();

  constructor() {
  }

}
